// extracted by mini-css-extract-plugin
export var arrow = "ButtonPager-module--arrow--e15f6";
export var img = "ButtonPager-module--img--1522d";
export var link = "ButtonPager-module--link--38e4c";
export var wrapper = "ButtonPager-module--wrapper--4dad9";